import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './popular.css';
import Item from '../Item/item';
import { EmptyState, ErrorMessage, ProductSkeleton, SectionHeader } from '../UI';
import { useProducts } from '../../hooks/useProducts';
import { getProductImageUrl, getProductId, getProductName, getProductPrices } from '../../utils/helpers';

const Popular = () => {
  const { t } = useTranslation(['common', 'products']);
  const { data, isLoading, error, refetch } = useProducts({ limit: 10 });
  const products = data?.products || [];

  if (isLoading) {
    return (
      <section className="new-arrivals-section">
        <div className="new-arrivals-container">
          <SectionHeader title={t('newArrivals', { defaultValue: 'New Arrivals', ns: 'common' })} />
          <div className="products-grid">
            <ProductSkeleton count={8} />
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="new-arrivals-section">
        <div className="new-arrivals-container">
          <SectionHeader title={t('newArrivals', { defaultValue: 'New Arrivals', ns: 'common' })} />
          <ErrorMessage
            message={t('errors.loadFailed')}
            onRetry={() => refetch()}
            retryText={t('errors.tryAgain')}
          />
        </div>
      </section>
    );
  }

  return (
    <section className="new-arrivals-section">
      <div className="new-arrivals-container">
        <SectionHeader title={t('newArrivals', { defaultValue: 'New Arrivals', ns: 'common' })}>
          <Link to="/search" className="view-all-btn">{t('viewAll', { ns: 'common' })}</Link>
        </SectionHeader>

        <div className="products-grid">
          {products.length > 0 ? (
            products.map((item, i) => {
              const { price, comparePrice, fromPrice } = getProductPrices(item);
              return (
                <Item
                  key={getProductId(item) || i}
                  id={getProductId(item)}
                  image={getProductImageUrl(item)}
                  name={getProductName(item)}
                  newPrice={price}
                  oldPrice={comparePrice}
                  fromPrice={fromPrice}
                  sold={item.sold || item.salesCount || 0}
                  rating={item.averageRating || item.rating || 4.5}
                  shipping={item.freeShipping ? t('freeShipping', { defaultValue: 'Free shipping', ns: 'common' }) : t('standardShipping', { defaultValue: 'Standard shipping', ns: 'common' })}
                />
              );
            })
          ) : (
            <EmptyState
              icon="package"
              title={t('empty.noProductsTitle')}
              description={t('empty.noProductsDescription')}
              actionText={t('empty.exploreShop')}
              actionLink="/search"
              variant="inline"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default Popular;
